import { Component, OnInit, OnDestroy } from '@angular/core';
import {UserService} from '../../_services/user.service';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MustMatch} from '../../_helpers/MustMatch';
import {User} from '../../_models/user';
import {ToastrService} from 'ngx-toastr';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-user-change-password',
    templateUrl: './user-change-password.component.html',
    styleUrls: ['./user-change-password.component.css'],
    standalone: false
})
export class UserChangePasswordComponent implements OnInit, OnDestroy {

  form: UntypedFormGroup;
  currentUser: User | null = null;
  submitted = false;
  private userSubscription: Subscription;

  constructor (public userService: UserService, private fb: UntypedFormBuilder, private toastr: ToastrService) {
    this.form = this.fb.group({
      oldPassword: new UntypedFormControl('', Validators.required),
      newPassword: new UntypedFormControl('', [Validators.required, Validators.minLength(6)]),
      confirmPassword: new UntypedFormControl('', Validators.required),
    }, { validator: MustMatch('newPassword', 'confirmPassword') });
    window.scrollTo(0, 0);
  }

  ngOnInit() {
    // Subscribe to user changes for reactive updates
    this.userSubscription = this.userService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  get f () {
    return this.form.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (!this.currentUser) {
      this.toastr.error('User not found');
      this.submitted = false;
      return;
    }
    this.userService.changeUserPassword(this.currentUser, this.form.value).subscribe(
        (result: any) => {
          this.toastr.success(result.message);
          this.form.reset();
        },
        () => { this.submitted = false; },
        () => {
          this.submitted = false;
        }
    );
  }

}
